import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import AnimatedElement from './AnimatedElement';

const VerbindungSection = () => {

  return (
    <Box
      id="verbindung"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: 'primary.white'
      }}
    >

      {/* Ganzflächiges Bild ohne Padding */}
      <Container
        maxWidth={false}
        sx={{
          maxWidth: '1400px',
          pl: { xs: 2, md: 14 }, // 80px = 10 * 8px (theme spacing)
          pr: 2,
          mx: 'auto',
          mb: 2
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '3fr 7fr 1fr' },
            gap: 2,
            alignItems: 'start'
          }}
        >
          <Box />

          <AnimatedElement>
            
          <Box
            component="img"
            src="/bild_3.webp" // Platzhalter-Bild
            alt="Vorteile des Corps Guestphalia"
            sx={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover',
              display: 'block',
              margin: { xs: '20px 0', md: '100px 0' }
            }}
          />
          </AnimatedElement>

          <Box></Box>

        </Box>
      </Container>


      <Container
        maxWidth={false}
        sx={{
          maxWidth: '1400px',
          pl: { xs: 2, md: 14 }, // 80px = 10 * 8px (theme spacing)
          pr: 2,
          mx: 'auto',
          mb: 8
        }}
      >
        <AnimatedElement>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '3fr 7fr 1fr' },
            gap: 2,
            alignItems: 'start'
          }}
        >
          {/* Spalte 1: Sektionsüberschrift */}
          <Box>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: { xs: '1.6rem', sm: '1.8rem', md: '2.1rem' },
                fontWeight: 500,
                color: '#000',
                lineHeight: 1.2,
                textAlign: 'left'
              }}
            >
              STUDENTEN-<br />VERBINDUNGEN
            </Typography>
           <Box 
                          sx={{
                            height: '4px', 
                            width: '100px', 
                            backgroundColor: 'rgb(58, 123, 62)', 
                            marginTop: { xs: '20px', sm: '30px', md: '40px' },
                            marginBottom: '20px'
                          }}
                        />
          </Box>

          {/* Spalte 2: Zweispaltiger Fließtext */}
          <Box>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.6,
                color: '#000',
                textAlign: 'left',
                columnCount: { xs: 1, md: 2 },
                columnGap: '2rem',
                margin: 0,
                '& p': {
                  breakInside: 'avoid',
                  pageBreakInside: 'avoid', // Fallback
                  marginTop: 0, // Entfernt Abstand über dem ersten Absatz
                  marginBottom: 2 // Abstand zwischen Absätzen
                },
                '& p:first-of-type': {
                  marginTop: 0 // Explizit für den ersten Absatz
                },
                columnRule: 'none',
                 marginLeft: { xs: '40px', md: 0 }
              }}
            >
              <p>Eine Studentenverbindung in Deutschland ist eine Gruppe von Studenten, die sich auf freiwilliger Basis zu einer Gemeinschaft zusammenschließen. Diese Gemeinschaften haben in der Regel einen starken Fokus auf Traditionen, Rituale und Werte, die oft seit Jahrzehnten oder sogar Jahrhunderten Bestand haben.</p>
              <p>Studentenverbindungen sind in Deutschland in verschiedene Typen unterteilt, wie zum Beispiel Studentenverbindungen mit einem politischen Schwerpunkt, die sich auf die Pflege bestimmter akademischer Disziplinen konzentrieren oder sich auf spezielle Interessengebiete wie Sport oder Musik konzentrieren. Es gibt auch Verbindungen, die ausschließlich für Frauen oder Männer bestimmt sind, obwohl in jüngerer Zeit auch gemischte Verbindungen zunehmend beliebt geworden sind.</p>
              <p>Die Mitgliedschaft in einer Studentenverbindung in Deutschland ist in der Regel sehr engagiert und erfordert von den Mitgliedern einen hohen Grad an Hingabe und Engagement. Viele Studentenverbindungen organisieren eine Vielzahl von Veranstaltungen und Aktivitäten wie Vorträge, gesellige Treffen, Sportveranstaltungen und Ausflüge, um das Gemeinschaftsgefühl und die Freundschaft unter den Mitgliedern zu fördern</p>
            </Typography>
          </Box>

          {/* Spalte 3: Gedrehter Text "CORPS" */}
          <Box
            sx={{
                 display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
              alignItems: 'flex-start',
              height: '100%',
              minHeight: { xs: '100px', md: '400px' }
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
              <div style={{ height: '100px', width: '2px', backgroundColor: '#3a7b3e', marginLeft: '-4px' }}></div>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: '0.8rem', md: '0.9rem' },
                  fontWeight: 500,
                  color: '#000',
                  writingMode: { xs: 'horizontal-tb', md: 'vertical-rl' },
                  textOrientation: { md: 'mixed' },
                  whiteSpace: 'nowrap',
                  letterSpacing: '0.2em',
                  textAlign: 'center',
                }}
              >
                VERBINDUNGEN
              </Typography>
            </div>

          </Box>
        </Box>
        </AnimatedElement>
      </Container>
    </Box>
  );
};

export default VerbindungSection;